module.exports = __webpack_public_path__ + "img/empty-box.d3f93298.png";